import { Nullable } from '@/shared/lib';

export type IncomingDocument = {
  id: number;
  file: string;
};

export const enum IncomingDocumentType {
  General = 'general',
  Fssp = 'fssp',
  CourtOrders = 'court_orders',
  Fines = 'fines',
}

export const incomingDocumentTypeI18n: Record<IncomingDocumentType, string> = {
  [IncomingDocumentType.General]: 'Общее',
  [IncomingDocumentType.Fssp]: 'ФССП',
  [IncomingDocumentType.CourtOrders]: 'Судебные приказы',
  [IncomingDocumentType.Fines]: 'Штрафы',
};

export type IncomingDocumentGroup<T extends Record<string, unknown> = Record<string, unknown>> = {
  id: number;
  documents: IncomingDocument[];
  created_at: string;
  updated_at: string;
  type: IncomingDocumentType;
  source?: Nullable<string>;
  source_id?: Nullable<string>;
  data: T;
  company: number;
  debtor?: Nullable<number>;
};

export type FsspIncomingDocumentGroupData = {
  amount: string;
  ip_number: string;
  doc_type: string;
  status_ts: string;
  id_type: string;
  id_name: string;
  id_date: string;
  id_number: string;
  case_date: string;
  case_number: string;
  id_issued_by: string;
  osp_name: string;
  osp_code: string;
  bailiff_fio: string;
  order_id: string;
  bailiff_phone: string;
  ip_date: string;
  debtor_type: 'fl' | 'ul';
  debtor_fio: string;
  debtor_dob: string;
  debtor_place_of_birth: string;
  debtor_pasp: string;
  debtor_inn?: Nullable<string>;
  debtor_snils?: Nullable<string>;
  ip_discontinued: boolean;
  ip_discontinued_at: string;
  ip_discontinued_art: string;
  ip_discontinued_art_part: string;
  ip_discontinued_art_clause: string;
};

export type FsspIncomingDocumentGroup = IncomingDocumentGroup<FsspIncomingDocumentGroupData> & {
  type: IncomingDocumentType.Fssp;
};
